import { render } from "./addlisting.vue?vue&type=template&id=2268b248&scoped=true"
import script from "./addlisting.vue?vue&type=script&lang=js"
export * from "./addlisting.vue?vue&type=script&lang=js"

import "./addlisting.vue?vue&type=style&index=0&id=2268b248&lang=scss&scoped=true"
import "./addlisting.vue?vue&type=style&index=1&id=2268b248&lang=scss"

import exportComponent from "/Users/arvindersingh/Desktop/projects/parsoftwares/rt-backend/backend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2268b248"]])

export default __exports__